import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import * as serviceWorker from './serviceWorker';
import { store } from './store';
import App from './App';

import './index.scss';
import { ReduxQueryContextProvider } from './utils/reduxQuery/useReduxMutation';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ReactQueryPlusProvider } from './utils/reactQueryPlus/provider';

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnMount: false,
			refetchOnWindowFocus: false,
		},
	},
});

ReactDOM.render(
	<ReactQueryPlusProvider>
		<QueryClientProvider client={queryClient}>
			<ReduxQueryContextProvider>
				<Provider store={store}>
					<App />
				</Provider>
			</ReduxQueryContextProvider>
			<ReactQueryDevtools />
		</QueryClientProvider>
	</ReactQueryPlusProvider>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
